import {
  ActionType,
  AutoTextField,
  BooleanField,
  SelectAutocompleteField,
} from '../../../components/AutoForm/AutoFieldNew';
import {planFeesFieldType} from '../CreateBuilder/BuilderPlanFees';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {modelPortfolioField} from '../BuilderModify/builderModifyFieldTypes';

export type newSubplanFields = {
  existingPotId: string | null;
  planFees?: planFeesFieldType;
  model?: modelPortfolioField;
};

export type newPlanParentFields = {
  planFees: planFeesFieldType;
  planProvider: string;
  productNameId: string;
  existingPotId?: string;
  parentGuardianId?: string;
  productProviderId?: string;
  inTrust?: boolean;
  contactId: string;
};

export type newPlanFields = {
  parent: newPlanParentFields;
  subplans?: newSubplanFields[];
};

export type setUpNewFields = newPlanFields;

export const setUpNewPlanProviderField: Omit<SelectAutocompleteField, 'id'> = {
  label: 'Select plan provider',
  type: ActionType.selectAutocomplete,
  options: [],
  initialValue: '',
};

export const setUpNewPlanTypeField: SelectAutocompleteField = {
  id: 'productNameId',
  label: 'Select product type',
  type: ActionType.selectAutocomplete,
  options: [],
  initialValue: '',
};

export const setUpNewPlanContactIdField: SelectAutocompleteField = {
  id: 'contactId',
  label: 'Plan contact',
  type: ActionType.selectAutocomplete,
  options: [],
  initialValue: '',
};

export const inTrustField: BooleanField<builderFieldsType> = {
  id: 'inTrust' as any,
  label: 'In Trust',
  type: ActionType.boolean,
  yesValue: true,
  noValue: false,
  labelNotClickable: true,
};

export const investorCategoryField: AutoTextField<builderFieldsType> = {
  id: 'investorCategory',
  label: 'Investor Category',
  type: ActionType.text,
  initialValue: '',
  readOnly: true,
};
